const $$ = s =>
  Array.prototype.slice.call(
    document.querySelectorAll(s)
  )
const isEl = obj => obj instanceof HTMLElement
const isStr = obj => Object.prototype.toString.call(obj) === '[object String]'
const rightWrapper = obj => document.getElementById('right-wrapper')

const cursorDot = ({
  zIndex = 100,
  diameter = 0,
  easing = 4
} = {}) => {
  let inited = false
  const alt = { x: 0, y: 0, o: 1, d: diameter }
  const cur = { x: 0, y: 0, o: 0, d: diameter }
  const dot = document.createElement('div')
  const dotChild =  document.createElement('div')
  const tim = easing / 15
  dot.classList = 'co--cursor'
  dot.id = 'co--cursor--id'
  dotChild.classList = 'co--cursor--div'
  dot.appendChild(dotChild);
  dot.style = `
    position:fixed;
    top:0;left:0;
    border-radius:100%;
    pointer-events:none;
    opacity:1;
    visibility: visible;
    z-index:${zIndex};
    height:${diameter}px;
    width:${diameter}px;
    transition:background ${tim}s,border ${tim}s;
    will-change:transform`

  document.addEventListener('mousemove', e => {
    alt.x = e.clientX
    alt.y = e.clientY
    dot.style.opacity = 1
    if (!inited) {
      document.body.append(dot)
      cur.x = alt.x
      cur.y = alt.y
      inited = true
      draw()
    }
  })

  const draw = () => {
    const dX = alt.x - cur.x
    const dY = alt.y - cur.y
    cur.x += (dX / easing)
    cur.y += (dY / easing)
    const t3d = `translate3d(${cur.x - cur.d / 2}px,${cur.y - cur.d / 2}px,0)`
    dot.style.webkitTransform = t3d
    dot.style.transform = t3d

    const dO = alt.o - cur.o
    cur.o += dO / easing
    dot.style.opacity = cur.o

    const dD = alt.d - cur.d
    cur.d += dD / easing
    dot.style.height = cur.d + 'px'
    dot.style.width = cur.d + 'px'

    try {
      requestAnimationFrame(draw)
    } catch (_) {
      setImmediate(draw)
    }
  }

  dot.over = (any, coClass) => {
    const fn = el => {
      el.addEventListener('mouseover', _ => {

        if (!dot.classList.contains(coClass)) dot.classList.add(coClass);

      })
      el.addEventListener('mouseout', _ => {

        if (dot.classList.contains(coClass)) dot.classList.remove(coClass);

      })
    }
    if (isEl(any)) fn(any)
    else if (isStr(any)) $$(any).forEach(fn)
  }

  // ==

  return dot
}

/* ============================================================================= */

const $ = s => document.querySelector(s);
